import { Box, Flex, Image, Text } from "@mantine/core";
import { SelectListItem } from "../../../../../model/SelectListItem";
type Props = {
  dataPrint: any;
  componentRef: any;
  valuePrintHandoverModal: any;
  locationData: any;
  dataCommuneMoi?: SelectListItem[];
};
const PrintHandover = ({
  dataPrint,
  componentRef,
  valuePrintHandoverModal,
  locationData,
  dataCommuneMoi,
}: Props) => {
  const dataTransaction = dataPrint?.tblInventoryTransactionModel;

  const dataSerials = dataPrint?.inventoryTransactionSerialModels; //list sản phẩm

  const useLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}"
  );
  const dataSerialsCheckTrung = dataSerials?.reduce((acc: any[], item: any) => {
    // lấy dữ liệu này nếu các sản phẩm bị trùng
    const existingItem = acc.find((i) => i.itemCode === item.itemCode);

    if (existingItem) {
      existingItem.primaryQuantity += item.primaryQuantity || 1; // Cộng số lượng từ item gốc
    } else {
      acc.push({ ...item, primaryQuantity: item.primaryQuantity || 1 }); // Giữ nguyên quantity nếu có, nếu không thì gán là 1
    }

    return acc;
  }, []);

  //TỔNG SỐ LƯỢNG
  const totalQuantity = dataSerials?.reduce(
    (total: number, item: any) => total + item.primaryQuantity,
    0
  );
  //Tổng tiền
  const totalAmount = dataSerials?.reduce((total: number, item: any) => {
    const price = Number(item?.soPrice);
    const quantity = Number(item?.primaryQuantity);

    return Number(total) + (price && quantity ? price * quantity : 0);
  }, 0);
  // console.log("dataPrint", dataPrint);
  // console.log("dataTransaction", dataTransaction);
  // console.log("valuePrintHandoverModal", valuePrintHandoverModal);
  // console.log("locationData", locationData);
  //   format lại ngày có kiểu ngày ... tháng ... năm
  const formatDateToVietnamese = (dateString: string): string => {
    if (!dateString) return "";

    const [day, month, year] = dateString.split("-");

    return `ngày ${day} tháng ${month} năm ${year}`;
  };
  //ĐỊNH DẠNG SỐ TIỀN
  const formatCurrency = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };
  return (
    <div
      ref={componentRef}
      style={{
        height: "100%",
        margin: "0 auto",
        marginLeft: "40px",
        marginRight: "30px",
        fontFamily: `"Times New Roman", Times, serif`,
        position: "relative",
      }}
    >
      <Box
        style={{
          width: "100%",
          position: "relative",
          margin: "0 auto",
          marginRight: "20px",
          paddingRight: "20px",
        }}
      >
        {/* header */}
        <Box>
          <Box style={{ textAlign: "center" }}>
            <Text size="md">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </Text>
            <Text size="md">Độc lập - Tự do - Hạnh phúc</Text>
            <Text
              fw={700}
              style={{
                fontSize: "23px",
                margin: "8px 0",
              }}
            >
              BIÊN BẢN BÀN GIAO VÀ NGHIỆM THU HÀNG HÓA
            </Text>
            <Text size="md"> Số : {dataTransaction?.sourceCode}</Text>
          </Box>
        </Box>
        {/* main */}
        <Box>
          <>
            <ul
              style={{
                margin: 0,
                padding: 0,
                listStyleType: "square",
                paddingLeft: "15px",
              }}
            >
              {valuePrintHandoverModal?.soHopDong ||
                valuePrintHandoverModal?.kyNgay === "" ? (
                <li>
                  Căn cứ vào <strong>Hợp đồng</strong>{" "}
                  {valuePrintHandoverModal?.soHopDong} ký{" "}
                  {formatDateToVietnamese(valuePrintHandoverModal?.kyNgay)} giữa{" "}
                  <strong> Công Ty Cổ Phần Đầu Tư Công Nghệ HACOM</strong> và{" "}
                  {dataTransaction?.tenCty}
                </li>
              ) : (
                ""
              )}
              {valuePrintHandoverModal?.maDonDatHang ? (
                <>
                  <li>
                    Căn cứ vào <strong>Đơn Đặt Hàng</strong>{" "}
                    {valuePrintHandoverModal?.maDonDatHang} của{" "}
                    {dataTransaction?.tenCty}
                  </li>
                </>
              ) : (
                ""
              )}
            </ul>
          </>

          <Box>
            <Text style={{ margin: "15px 0" }}>
              Hôm nay,{" "}
              {formatDateToVietnamese(valuePrintHandoverModal?.ngayBanGiao)},
              chúng tôi gồm:
            </Text>
          </Box>

          <Box>
            <Box>
              <Text fw={700} size="lg">
                BÊN BÁN(BÊN A)
              </Text>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Công ty</Text>
                </div>
                <div>
                  <Text size="md">
                    : <strong> Công Ty Cổ Phần Đầu Tư Công Nghệ HACOM</strong>
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px", minWidth: "100px" }}>
                  <Text size="md">Địa chỉ</Text>
                </div>
                <div>
                  <Text size="md">
                    : Số 129 + 131 Lê Thanh Nghị, Phường Bạch Mai, Thành phố Hà
                    Nội
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Số điện thoại</Text>
                </div>
                <div>
                  <Text size="md">: 1900 1903</Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Mã số thuế</Text>
                </div>
                <div>
                  <Text size="md">: 0101161194</Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Người đại diện</Text>
                </div>
                <div>
                  <Text size="md">
                    : {valuePrintHandoverModal?.daiDienBenBan}
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Chức vụ</Text>
                </div>
                <div>
                  <Text size="md">
                    : {valuePrintHandoverModal?.chucVuBenBan}
                  </Text>
                </div>
              </Flex>
            </Box>
            <Box>
              <Text fw={700} size="lg">
                BÊN MUA(BÊN B)
              </Text>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Công ty</Text>
                </div>
                <div>
                  <Text size="md">
                    : <strong>{dataTransaction?.tenCty}</strong>
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px", minWidth: "100px" }}>
                  <Text size="md">Địa chỉ</Text>
                </div>
                <div>
                  <Text size="md">
                    :{" "}
                    {/* {dataTransaction?.dvtn != null
                      ? `${locationData?.customerAddress} - ${locationData?.wardName} - ${locationData?.districtName} - ${locationData?.provinceName}`
                      : `${dataTransaction?.cusAddress} - ${dataTransaction?.cusCommuneName} - ${dataTransaction?.cusDestrictName} - ${dataTransaction?.cusProvinceName}`}{" "} */}
                    {dataCommuneMoi
                      ? `${dataCommuneMoi?.[0]?.text} - ${dataCommuneMoi?.[0]?.att1}`
                      : ""}
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Số điện thoại</Text>
                </div>
                <div>
                  <Text size="md">
                    :{" "}
                    {dataTransaction?.dvtn !== null
                      ? locationData?.telephoneNumber
                      : dataTransaction?.cusTelephone}
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Mã số thuế</Text>
                </div>
                <div>
                  <Text size="md">: {dataTransaction?.attribute4} </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Người đại diện</Text>
                </div>
                <div>
                  <Text size="md">
                    :{" "}
                    {dataTransaction?.dvtn !== null
                      ? locationData?.customerName
                      : `${dataTransaction?.cusName}`}
                    {/* : `${dataTransaction?.cusName}-${dataTransaction?.cusCode}`} */}
                  </Text>
                </div>
              </Flex>
              {valuePrintHandoverModal?.chucVuBenMua ? (
                <>
                  <Flex
                    direction={"row"}
                    align={"center"}
                    justify={"flex-start"}
                    style={{ margin: "3px 0" }}
                  >
                    <div style={{ width: "100px" }}>
                      <Text size="md">Chức vụ</Text>
                    </div>
                    <div>
                      <Text size="md">
                        : {valuePrintHandoverModal?.chucVuBenMua}
                      </Text>
                    </div>
                  </Flex>
                </>
              ) : (
                ""
              )}
            </Box>
          </Box>

          <Box>
            <Text size="md" style={{ margin: "10px 0" }}>
              Hai bên tiến hành bàn giao và nghiệm thu hàng hóa với nội dung
              sau:{" "}
            </Text>
            <Text size="lg" fw={700}>
              1. THIẾT BỊ ĐÃ BÀN GIAO
            </Text>
            <ul
              style={{
                listStyleType: "none",
                margin: 0,
                padding: 0,
                paddingLeft: "15px",
              }}
            >
              <li>
                <strong
                  style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}
                >
                  BÊN A
                </strong>
                {"  "}
                bàn giao đầy đủ cho{"  "}
                <strong
                  style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}
                >
                  BÊN B
                </strong>
                {"  "}
                các thiết bị như sau
              </li>
              <li>
                {/* table sản phẩm */}
                <div
                  // className={styles.ProductMain}
                  style={{
                    width: "100%",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      border: "1px solid black",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          STT
                        </th>
                        <th
                          style={{
                            width: "40px",
                            border: "1px solid black",
                          }}
                        >
                          Mã Hàng
                        </th>
                        {valuePrintHandoverModal?.hienThi1 === "Serial" ? (
                          <th
                            style={{
                              width: "20px",
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            Serial
                          </th>
                        ) : (
                          ""
                        )}

                        <th
                          // className={styles.thNameProduct}
                          style={{
                            width: "370px",
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Tên sản phẩm
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          ĐVT
                        </th>

                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          SL
                        </th>

                        {valuePrintHandoverModal?.hienThi2 === "CoGia" ? (
                          <>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "60px",
                              }}
                            >
                              Giá bán
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "130px",
                              }}
                            >
                              Thành tiền
                            </th>
                          </>
                        ) : (
                          ""
                        )}

                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Tình trạng
                        </th>

                        <th
                          style={{
                            border: "1px solid black",
                            width: "150px",
                            textAlign: "center",
                          }}
                        >
                          Thời gian BH
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                            width: "150px",
                            textAlign: "center",
                          }}
                        >
                          Ghi chú
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        <tr>
                          <td
                            colSpan={
                              valuePrintHandoverModal?.hienThi1 === "Serial"
                                ? 6
                                : 5
                            }
                            style={{
                              textAlign: "end",
                              marginRight: "5px",
                              border: "none",
                              paddingRight: "5.5px",
                            }}
                          >
                            {totalQuantity}
                          </td>
                          <td style={{ border: "none" }}></td>

                          {valuePrintHandoverModal &&
                            valuePrintHandoverModal?.hienThi2 === "CoGia" && (
                              <>
                                <td
                                  style={{
                                    textAlign: "end",
                                    border: "none",
                                  }}
                                >
                                  {formatCurrency(totalAmount)}
                                </td>
                              </>
                            )}

                          <td style={{ border: "none" }} colSpan={2}></td>
                        </tr>
                      </>
                      {(valuePrintHandoverModal?.hienThi1 === "Sl"
                        ? dataSerialsCheckTrung
                        : dataSerials
                      )?.map((item: any, index: number) => {
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                textAlign: "center",
                                border: "1px solid black",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                              }}
                            >
                              {" "}
                              {item?.itemCode}
                            </td>
                            {valuePrintHandoverModal?.hienThi1 === "Serial" ? (
                              <td
                                style={{
                                  width: "20px",
                                  wordWrap: "break-word",
                                  border: "1px solid black",
                                }}
                              >
                                {item?.serial}
                              </td>
                            ) : (
                              ""
                            )}

                            <td
                              style={{
                                // width: "380px !important",
                                textAlign: "start",
                                border: "1px solid black",
                                paddingLeft: "3px",
                              }}
                            >
                              {item?.itemName}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {item?.primaryUomCode}{" "}
                            </td>

                            <td
                              style={{
                                textAlign: "center",
                                border: "1px solid black",
                              }}
                            >
                              {item?.primaryQuantity}
                            </td>

                            {valuePrintHandoverModal?.hienThi2 === "CoGia" ? (
                              <>
                                <td
                                  style={{
                                    textAlign: "end",
                                    border: "1px solid black",
                                  }}
                                >
                                  {formatCurrency(item?.soPrice)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    border: "1px solid black",
                                  }}
                                >
                                  {formatCurrency(
                                    item?.soPrice * item?.primaryQuantity
                                  )}
                                </td>
                              </>
                            ) : (
                              ""
                            )}

                            <td
                              style={{
                                border: "1px solid black",
                              }}
                            >
                              {item?.serialStatus}
                            </td>

                            <td
                              style={{
                                textAlign: "end",
                                border: "1px solid black",
                              }}
                            >
                              {/* 30 ngày */}
                              {item?.attribute3 == null
                                ? ""
                                : item?.attribute3}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                              }}
                            >
                              {item?.note}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
            <Text size="lg" fw={700} style={{ marginTop: "10px" }}>
              2. KIỂM TRA VÀ NGHIỆM THU
            </Text>
            <ul
              style={{
                listStyleType: "square",
                margin: 0,
                padding: 0,
                paddingLeft: "15px",
              }}
            >
              <li>
                <strong
                  style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}
                >
                  BÊN A
                </strong>
                {"  "}
                đã hoàn thành việc cung cấp, lắp đặt và bàn giao hàng hóa đúng:
                số lượng, chủng loại, chất lượng, tình trạng như đã thỏa thuận,
                đầy đủ linh phụ kiện và hoạt động tốt.
              </li>
              <li>
                Biên bản này được lập thành <strong>03</strong> bản, có giá trị
                pháp lý như nhau
              </li>
            </ul>
          </Box>

          <Box style={{ pageBreakInside: "avoid" }}>
            <Flex
              direction={"row"}
              align={"center"}
              justify={"space-evenly"}
              style={{ marginTop: "20px" }}
            >
              <Text fw={700} size="lg">
                ĐẠI DIỆN BÊN A
              </Text>
              <Text fw={700} size="lg">
                ĐẠI DIỆN BÊN B
              </Text>
            </Flex>
          </Box>
        </Box>
      </Box>
      <Box
        style={{
          position: "absolute",
          width: "100%",
          zIndex: -1,
          opacity: 0.1,
          top: "40%",
        }}
      >
        <Image
          radius="md"
          src="https://hanoicomputercdn.com/media/lib/17-10-2024/logo-hacom-since-2001_new.png"
          style={{
            width: "90%",
            margin: "0 auto",
          }}
        />
      </Box>
    </div>
  );
};

export default PrintHandover;
